module.exports = __webpack_public_path__ + "img/achievement1.c501c5b7.jpg";